// Types
import { RootState } from 'types/RootState.types';

export const getAuth0AccessTokenSelector = (state: RootState) => state.mobileApps?.auth0AccessToken;
export const getRequestAccessTokenSelector = (state: RootState) => state.mobileApps?.requestAccessToken;
